import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { StaticSettingsRoutes, useSettingsNavigate } from '@frontend/settings-routing';
import { theme } from '@frontend/theme';
import { NakedButton, styles } from '@frontend/design-system';

export const SettingsNavButton = ({ label, path }: { label: string; path: StaticSettingsRoutes }) => {
  const { navigate } = useSettingsNavigate();
  const { t } = useTranslation();
  return (
    <NakedButton
      onClick={() => navigate({ to: path, originLabel: label })}
      css={css`
        display: flex;
        gap: ${theme.spacing(1)};
        width: 100%;
        padding: ${theme.spacing(1, 2, 1, 1)};
        text-align: left;
        border-radius: ${theme.borderRadius.medium};
        transition: background-color 0.3s ease-in-out;
        color: ${theme.font.colors.default};
        :hover {
          background-color: ${theme.colors.neutral5};
        }
      `}
    >
      <Icon name='settings' />{' '}
      <span css={styles.truncate}>
        {label} {t('Settings')}
      </span>
    </NakedButton>
  );
};
